<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :extra-bottom-padding="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-section-header title="MOBIB-kaart">
        <template #right>
          <o-icon icon="info" @click.native="showOverlay('info')" />
        </template>
      </o-section-header>
      <o-section>
        <p>
          Heb je een MOBIB-kaart? Dan kan je deze eventueel ook als back-up
          gebruiken als er geen mobiele dataverbinding beschikbaar is.
        </p>
        <o-text-input label="Omschrijving kaart" />
      </o-section>
      <o-section>
        <o-text-input label="Kaartnummer" />
      </o-section>
      <o-section>
        <o-text-input label="Serienummer" />
      </o-section>
      <o-section>
        <p>
          Heb je nog geen MOBIB-kaart? Wend je naar een loket van De Lijn, MIVB,
          NMBS of TEC. <a href="#">Meer info over MOBIB-kaarten.</a>
        </p>
      </o-section>
      <o-overlay ref="info">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
          consectetur accumsan libero. Nullam quis elit at metus viverra tempor.
          Vivamus metus magna, dapibus at lacus et, tincidunt cursus tellus.
        </p>
      </o-overlay>
    </o-view>
    <o-pay-button
      label="Bewaren"
      to="/sales/car/cambio/onboarding/mobib-picture"
    />
  </o-view>
</template>

<script>
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OStarRating from '@/components/OStarRating.vue'
import OSection from '@/components/base/OSection'
export default {
  name: 'CambioCurrent',
  components: {
    OSection,
    OHeaderImage,
    OPayButton,
    OStarRating
  },
  data() {
    return {
      pin: '• • • •'
    }
  },
  methods: {
    showPin() {
      this.pin = '4321'
    }
  }
}
</script>
